// Buy Now Custom Element
class BuyNow extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', this.handleClick.bind(this));
  }

  handleClick(e) {
    e.preventDefault();

    const variantId = this.getAttribute('data-variant-id');
    const quantity = parseInt(this.getAttribute('data-quantity')) || 1;

    if (!variantId) {
      console.error('Buy Now: Variant ID is required');
      return;
    }

    // 构建购物车URL并跳转
    this.checkoutWithMultipleItems(variantId, quantity);
  }

  checkoutWithMultipleItems(variantId, quantity) {
    const productInfo = [{ 'variantId': variantId, 'quantity': quantity }];
    const baseUrl = '/cart/';
    const cartQuery = productInfo
      .map(function (item) {
        return item.variantId + ':' + item.quantity;
      })
      .join(',');
    console.log(cartQuery, baseUrl, baseUrl + cartQuery);
    window.location = baseUrl + cartQuery;

  }

  connectedCallback() {
    // 确保加载状态指示器正常显示
    if (!this.hasAttribute('data-initialized')) {
      this.setAttribute('data-initialized', 'true');
    }
  }
}

// 注册自定义元素
if (!customElements.get('buy-now')) {
  customElements.define('buy-now', BuyNow);
}


